import styled from '@emotion/styled';

import { Gray_Light_150, Gray_Light_400, Gray_Light_600 } from '@common/styles';

export const Root = styled.div`
  display: flex;
  align-items: center;

  .score {
    color: ${Gray_Light_600};
  }

  .review-count {
    color: ${Gray_Light_400};
  }
`;

export const Hr = styled.hr`
  width: 1px;
  height: 9px;
  margin: 0 4px;
  background-color: ${Gray_Light_150};
  border: none;
`;
